<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage titlePage="Histórico" />
    <b-row>
      <b-col cols="6" class="pb-4">
        <fcc-select
          class="mb-4"
          placeholder="Selecione uma tabela"
          v-model="tabelaSelecionada"
          :options="tabelas"
          @input="listarCamposDisponiveis"
          :clearable="false"
          required
        >
          Tabela
        </fcc-select>
      </b-col>
      <b-col>
        <fcc-button @click="adicionarCamposDisponiveis" :disabled="lstSelecionado.length <= 0">
          Transferir
        </fcc-button>
        <fcc-button @click="alteraHistorico" class="ml-2"> Salvar Alterações </fcc-button>
      </b-col>
      <b-col cols="6">
        <fcc-table
          striped
          hover
          :fields="fieldsCampos"
          responsive
          por-page="1000"
          @row-selected="atualizaSelecionado"
          :items="lstCampos"
        />
      </b-col>
      <b-col cols="6">
        <fcc-table
          striped
          hover
          :fields="fieldsHistorico"
          responsive
          por-page="1000"
          :items="lstHistorico"
          :actions="actionsHistorico"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      fieldsHistorico: [
        { key: 'logcampo', label: 'Campo', sortable: true },
        { key: 'logdescricao', label: 'Descrição', sortable: true, type: 'input' },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print' }
      ],
      fieldsCampos: [
        {
          key: 'rowSelect',
          sortable: false,
          type: 'rowSelect'
        },
        { key: 'logcampo', label: 'Campo', sortable: true }
      ],
      lstHistorico: [],
      actionsHistorico: [
        {
          button: true,
          funcaoButton: 'deleteHistorico',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      tabelas: ['Candidato', 'CandidatoEndereco', 'CandidatoContato'],
      tabelaSelecionada: 'Candidato',
      lstCampos: [],
      lstSelecionado: []
    }
  },
  mounted() {
    this.listarCamposDisponiveis()
  },
  methods: {
    alteraHistorico() {
      this.callConfirm('Deseja salvar alterações?', '').then(() => {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            store.state.baseUrlConcursos + 'CandidatoLogMongo/Alterar',
            this.lstHistorico,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.callToast(this.mensagensUpdate.editado)
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto)
      })
    },
    adicionarCamposDisponiveis() {
      this.callConfirm('Deseja transferir campo?', '').then(() => {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            store.state.baseUrlConcursos + 'CandidatoLogMongo/Adicionar',
            this.lstSelecionado,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.callToast(this.mensagensUpdate.adicionado, 'success')
            this.listarCamposDisponiveis()
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto)
      })
    },
    deleteHistorico(_, item) {
      this.callConfirm(this.mensagemExcluir, item.logdescricao).then(() => {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .delete(
            store.state.baseUrlConcursos + 'CandidatoLogMongo/Excluir/' + item.logid,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarCamposDisponiveis()
            this.callToast(this.mensagensUpdate.excluido, 'success')
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
          .finally(this.carregaTexto())
      })
    },
    listarCamposDisponiveis() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlConcursos +
            `CandidatoLogMongo/ListarCamposDisponiveis?tabela=${this.tabelaSelecionada}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCampos = response.data
          this.lstCampos = this.lstCampos.map((item) => {
            return {
              logcampo: item,
              logtabela: this.tabelaSelecionada,
              logativo: true,
              logdescricao: item
            }
          })
          this.listarHistorico()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarHistorico() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlConcursos + `CandidatoLogMongo/Listar`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstHistorico = response.data
          this.lstCampos = this.lstCampos.filter((elem) => {
            return !this.lstHistorico.some((ele) => {
              return ele.logcampo === elem.logcampo
            })
          })
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    atualizaSelecionado(items) {
      this.lstSelecionado = items
    }
  }
}
</script>
